export const basicConvertDate = (date) =>{
    var newDate = new Date(date).toLocaleDateString("en-US");
    return newDate;
}

export const convertDateWithTime = (date) =>{
    var newDate = new Date(date)
    var newDateString = newDate.toLocaleDateString("en-US");
   var newTime = new Date(date).toLocaleTimeString("en-US",{ hour: '2-digit', minute: '2-digit' });
    return newDateString + " " + newTime;

}

export const convertDateMonth = (date) =>{
    const options = {month: 'numeric', day: 'numeric' };
    var newDate = new Date(date).toLocaleDateString("en-US", options);
    return newDate;
}